// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("channels")
require('jquery')
import $ from "jquery";
import 'cocoon-js';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

// chartkick + chart.js は本番ビルドの 1.1MB を占めるうえ、グラフのある画面でしか要らない。
// 画面にグラフがあるときだけ動的に読み込む
// @see javascripts/shared/charts.js
import setupCharts from './javascripts/shared/charts';
setupCharts();

// fortawesome
// JS 版 (js/all) は全アイコンの定義を読み込んだうえで DOM を走査し <i> を <svg> に
// 置き換える。本番ビルドで 1.9MB のベンダーチャンクになっていたため、
// Web フォント版に切り替えた。マークアップ (<i class="fas fa-search">) はそのまま使える。
// @see https://github.com/exestinc/video_db/issues/2904
import '@fortawesome/fontawesome-free/css/all.css'

$(document).on("turbolinks:load", function() {
  $(".navbar-burger").click(function() {
    $(".navbar-burger").toggleClass("is-active");
    $(".navbar-menu").toggleClass("is-active");
  });
});

// style
require("./stylesheets/application.scss");

// select2
require("select2/dist/css/select2.css");
import Select2 from "select2";
$.fn.select2.defaults.set("width", "100%");
$(document).on("turbolinks:load", function() {
  $(".js-searchable").select2()

  $('#video-content-material-fields').on('cocoon:after-insert', function() {
    $('.js-searchable').select2();
  });
});

// jpostal
require('jquery-jpostal-ja');

$(document).on("turbolinks:load", function() {
  $(window).ready(function() {
    $('#zip').jpostal({
      postcode : ['#zip'],
      address : { '#address'  : '%3%4%5%6%7'}
    });
  });
});

/*-----------
 Modal
-----------*/
document.addEventListener('turbolinks:load', () => {
// Save DOM Elements
  const modalTriggers = document.querySelectorAll(".modal-trigger");
  const modalCloses = document.querySelectorAll(".modal-close, .modal-background, .modal-content a");

// Set click event handlers on each of the triggers.
  Array.from(modalTriggers).forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      const modalName = trigger.dataset.modal;
      const modal = document.querySelector(`.${modalName}`);
      modal.classList.add("is-active");
      document.querySelector('html').classList.add("is-clipped");
    });
  });

// Set click event handlers on the different close modal triggers.
  Array.from(modalCloses).forEach((closeSymbol) => {
    closeSymbol.addEventListener("click", function () {
      this.closest(".modal").classList.remove("is-active");
      document.querySelector('html').classList.remove("is-clipped");
    });
  });
});

// 読み込まれた時点で動く共通スクリプト。以前はそれぞれ独立した pack で、レイアウトや
// パーシャルから javascript_pack_tag / append_javascript_pack_tag していた。
// いずれも対象の要素が無ければ何もしないため、application と一緒に読み込んで問題ない。
// @see https://github.com/exestinc/video_db/issues/2397
import './javascripts/shared/flashControl';
import './javascripts/shared/checkboxControl';
import './javascripts/shared/signupModalControl';
import './javascripts/shared/turnstile';
import './javascripts/shared/purchaseForm';

// 画面ごとの初期化スクリプト。
// ビューが body の data-view-script で名前を宣言し、ディスパッチャがここから引いて呼ぶ。
// 以前は window.DD.<名前空間> にぶら下げてビューのインライン script から直接呼んでいたが、
// CSP の 'unsafe-inline' が必要になり、外部スクリプトを defer にもできなかった (#2935)。
// キーは app/views 側の register_view_script と一致していること
// (食い違いは spec/helpers/view_script_helper_spec.rb が検出する)。
import runViewScripts from './javascripts/shared/viewScript';

import activateSidebarLink from './javascripts/shared/activateSidebarLink';
import welcomeIndex from './javascripts/views/welcome/index';
import searchIndex from './javascripts/views/search/index';
import freeVideoCampaignsShow from './javascripts/views/free_video_campaigns/show';
import providersShow from './javascripts/views/providers/show';
import adminVideosNew from './javascripts/views/admin/videos/new';
import adminVideosEdit from './javascripts/views/admin/videos/edit';
import adminVideosShow from './javascripts/views/admin/videos/show';
import adminFreeVideosShow from './javascripts/views/admin/videos/free_videos/show';
import adminFreeVideoCampaignsNew from './javascripts/views/admin/free_video_campaigns/new';
import adminFreeVideoCampaignsEdit from './javascripts/views/admin/free_video_campaigns/edit';
import adminOrganizationsIndex from './javascripts/views/admin/organizations/index';
import providerVideosNew from './javascripts/views/provider/videos/new';
import providerVideosEdit from './javascripts/views/provider/videos/edit';
import providerVideosShow from './javascripts/views/provider/videos/show';
import providerVideosIndex from './javascripts/views/provider/videos/index';
import providerFreeVideosShow from './javascripts/views/provider/videos/free_videos/show';
import creatorVideoContentsNew from './javascripts/views/creator/video_contents/new';
import creatorVideoContentsEdit from './javascripts/views/creator/video_contents/edit';
import creatorVideoContentsShow from './javascripts/views/creator/video_contents/show';
import videosShow from './javascripts/views/videos/show';
import videoContentsShow from './javascripts/views/video_contents/show';
import ticketDealsNew from './javascripts/views/customer/ticket_deals/new';
import purchasesNew from './javascripts/views/customer/purchases/new';

runViewScripts({
  // レイアウト共通 (サイドバーの現在地表示)
  'layouts/admin': activateSidebarLink,
  'layouts/dashboard': activateSidebarLink,

  // 公開ページ
  'welcome/index': welcomeIndex,
  'search/index': searchIndex,
  'free_video_campaigns/show': freeVideoCampaignsShow,
  'providers/show': providersShow,
  'videos/show': videosShow,
  'video_contents/show': videoContentsShow,

  // 管理画面
  'admin/videos/new': adminVideosNew,
  'admin/videos/edit': adminVideosEdit,
  'admin/videos/show': adminVideosShow,
  'admin/videos/free_videos/show': adminFreeVideosShow,
  'admin/free_video_campaigns/new': adminFreeVideoCampaignsNew,
  'admin/free_video_campaigns/edit': adminFreeVideoCampaignsEdit,
  'admin/organizations/index': adminOrganizationsIndex,

  // 放送局 (provider)
  'provider/videos/new': providerVideosNew,
  'provider/videos/edit': providerVideosEdit,
  'provider/videos/show': providerVideosShow,
  'provider/videos/index': providerVideosIndex,
  'provider/videos/free_videos/show': providerFreeVideosShow,

  // クリエイター
  'creator/video_contents/new': creatorVideoContentsNew,
  'creator/video_contents/edit': creatorVideoContentsEdit,
  'creator/video_contents/show': creatorVideoContentsShow,

  // 会員 (customer)
  'customer/ticket_deals/new': ticketDealsNew,
  'customer/orders/purchases/new': purchasesNew
});
